import { type Icon } from '@factorialco/deprecated-design-system'

import { Model } from 'modules/core/lib/mobx-rest'

interface INotifier {
  identifier: string
  title: string
  description: string
  category: string
  category_title: string
  category_icon: React.ComponentProps<typeof Icon.Large>['icon']
  channels: Record<string, NotifierChannel>
  order_in_category?: number
  scopes?: Record<string, string>
}

interface NotifierChannel {
  editable: boolean
}

export default class Notifier extends Model<INotifier> {
  static urlRoot() {
    return '/notifications/notifiers'
  }

  get identifier(): string {
    return this.get('identifier')
  }

  get title(): string {
    return this.get('title')
  }

  get description(): string {
    return this.get('description')
  }

  get category(): string {
    return this.get('category')
  }

  get categoryTitle(): string {
    return this.get('category_title')
  }

  get categoryIcon(): React.ComponentProps<typeof Icon.Large>['icon'] {
    return this.get('category_icon')
  }

  get channels(): Record<string, NotifierChannel> {
    return this.get('channels')
  }

  get orderInCategory(): number | undefined {
    return this.get('order_in_category')
  }

  get scopes(): Record<string, string> | undefined {
    return this.get('scopes')
  }
}
